import { AUTH_ERROR } from '../auth/auth.error';
import { EQUITY_CHANGE_ERROR } from '../equity-change/equity-change.error';
import { FILE_ERROR } from '../file/file.error';
import { FILE_ARCHIVE_ERROR } from '../file-archive/file-archive.error';
import { FUND_ERROR } from '../fund/fund.error';
import { INVESTMENT_ERROR } from '../investment/investment.error';
import { MEMBER_ERROR } from '../member/member.error';
import { NOTIFICATION_ERROR } from '../notification/notification.error';
import { PORTFOLIO_ERROR } from '../portfolio/portfolio.error';
import { PORTFOLIO_FILE_ERROR } from '../portfolio-file/portfolio-file.error';
import { PORTFOLIO_MANAGE_ERROR } from '../portfolio-manage/portfolio-manage.error';
import { PORTFOLIO_MEMO_ERROR } from '../portfolio-memo/portfolio-memo.error';
import { PORTFOLIO_REPORT_ERROR } from '../portfolio-report/portfolio-report.error';
import { ROUND_ERROR } from '../round/round.error';
import { SCHEDULED_MAIL_ERROR } from '../scheduled-mail/scheduled-mail.error';
import { COMMON_ERROR } from './common.error';

/**
 * 에러 코드 레지스트리. 도메인별 `<domain>.error.ts` 를 여기서 합친다.
 * 도메인 코드를 추가하는 주체는 X3(seam-protocol)다.
 */
export const ERROR_REGISTRY = {
  ...COMMON_ERROR,
  ...AUTH_ERROR,
  ...FUND_ERROR,
  ...INVESTMENT_ERROR,
  ...ROUND_ERROR,
  ...EQUITY_CHANGE_ERROR,
  ...MEMBER_ERROR,
  ...PORTFOLIO_ERROR,
  ...PORTFOLIO_REPORT_ERROR,
  ...PORTFOLIO_MEMO_ERROR,
  ...PORTFOLIO_MANAGE_ERROR,
  ...NOTIFICATION_ERROR,
  ...FILE_ERROR,
  ...FILE_ARCHIVE_ERROR,
  ...PORTFOLIO_FILE_ERROR,
  ...SCHEDULED_MAIL_ERROR,
} as const;

export type ErrorCode = keyof typeof ERROR_REGISTRY;

export function isErrorCode(value: unknown): value is ErrorCode {
  return typeof value === 'string' && Object.hasOwn(ERROR_REGISTRY, value);
}
